import styled from 'styled-components';
import { colors } from '../../../theme/colors';
import { typography } from '../../../theme/typography';
import {
  FormContainer as Container,
  FormLabel as Label,
  FormError as ErrorText,
  formSizeStyles as sizeStyles,
} from '../../sharedFormStyles';

export { Container, Label, ErrorText };

const getSpacingSm = (props) => (props.theme && props.theme.spacing && props.theme.spacing.sm) || '8px';
const getSurfaceBg = (props) => (props.theme && props.theme.colors && props.theme.colors.surface && props.theme.colors.surface.background) || '#f0f0f0';
const getTextPrimary = (props) => (props.theme && props.theme.colors && props.theme.colors.text && props.theme.colors.text.primary) || (colors.text && colors.text.primary) || '#091b26';
const getTextSecondary = (props) => (props.theme && props.theme.colors && props.theme.colors.text && props.theme.colors.text.secondary) || '#666';
const getTextMuted = (props) => (props.theme && props.theme.colors && props.theme.colors.text && props.theme.colors.text.muted) || '#999';
const getFontFamily = (props) => (props.theme && props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'inherit';

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${(props) => (props.hasError ? colors.error : '#e0e0e0')};
  border-radius: 4px;
  background-color: ${(props) => (props.disabled ? colors.brandOffWhite : '#ffffff')};
  transition: border-color 0.2s, box-shadow 0.2s;
  width: 100%;
  padding: 0 ${props => getSpacingSm(props)};

  &:hover {
    ${(props) => !props.disabled && `
      border-color: ${props.hasError ? colors.error : '#b5b5b5'};
    `}
  }

  &:focus-within {
    ${(props) => !props.disabled && `
      border-color: ${props.hasError ? colors.error : colors.brandLightBlue};
      box-shadow: 0 0 0 3px ${props.hasError ? 'rgba(220, 53, 69, 0.25)' : 'rgba(0, 169, 255, 0.25)'};
    `}
  }

  ${(props) => props.disabled && `
    border-color: ${getSurfaceBg(props)};
    cursor: not-allowed;
  `}
`;

export const StyledInput = styled.input`
  flex: 1;
  border: none;
  background-color: transparent;
  width: 100%;
  box-sizing: border-box;
  color: ${props => getTextPrimary(props)};
  font-family: ${props => getFontFamily(props)};
  outline: none;
  padding-left: 4px;
  text-align: right;

  ${(props) => sizeStyles[props.size] || sizeStyles.md}

  &::placeholder {
    color: ${props => getTextMuted(props)};
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    color: ${props => getTextMuted(props)};
  }
`;

export const CurrencySymbol = styled.span`
  color: ${props => getTextSecondary(props)};
  font-weight: 600;
  margin-right: 4px;
  font-size: ${props => (props.size && typography.fontSize[props.size] ? typography.fontSize[props.size] : typography.fontSize.sm)};
  user-select: none;
  ${(props) => props.disabled && `color: ${getTextMuted(props)};`}
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/CurrencyInput/components/CurrencyInputStyles.js